import {Link} from "react-router-dom";
import OrderTab from "../../../components/OrderTab";
import AppLayout from "../../../layouts/AdminLayout";
import {useRoles} from "../../../hooks/useRoles";

export const OrderMgt = () => {
  const {scope} = useRoles();

  return (
    <AppLayout>
      {/* <NavHeader title="Order Management" /> */}

      {/* <Filter
        handleSearchFilter={setSearchFilter}
        showRiderFilter={true}
        loading={isLoadingOrderData}
      /> */}

      <div className="flex items-center justify-between !py-10 !px-9">
        <div>
          <h3 className="!text-[28px] !font-bold !text-[#272835]">
            Order Management
          </h3>
          <p className="!text-sm !text-[#818898]">
            View and track all your orders
          </p>
        </div>
        {scope === "write" && (
          <Link
            to={"/orders/create"}
            className="!text-sm !font-bold !text-white px-4 py-3 bg-[#f27f1f] rounded-[10px]"
          >
            Create Order
          </Link>
        )}
      </div>

      <OrderTab />
    </AppLayout>
  );
};
